const data = [
  {
    key: 1,
    name: {
      name: 'Mappe 1',
      type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
    },
    size: '134 Kb',
    children: [
      {
        key: 11,
        name: {
          name: 'Mappe 1-1',
          type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
        },
        size: '38 Kb',
      },
      {
        key: 12,
        name: {
          name: 'Mappe 1-2',
          type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
        },
        size: '134 Kb',

        children: [
          {
            key: 121,
            name: {
              name: 'Hus byggetilladelse af 7. Nov.docx',
              type: { icon: 'file-word', iconStyle: 'fad', color: 'blue' },
            },
            size: '53 Kb',
          },
        ],
      },
      {
        key: 13,
        name: {
          name: 'Mappe 1-3',
          type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
        },
        size: '38 Kb',

        children: [
          {
            key: 131,
            name: {
              name: 'Mappe 1-3-1',
              type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
            },
            size: '24 Kb',

            children: [
              {
                key: 1311,
                name: {
                  name: '001_Byggetilladelse af 4. juli 2016.pdf',
                  type: { icon: 'file-pdf', iconStyle: 'fad', color: 'red' },
                },
                size: '1.5 Mb',
              },
              {
                key: 1312,
                name: {
                  name: 'New Dokument.docx',
                  type: { icon: 'file-word', iconStyle: 'fad', color: 'blue' },
                },
                size: '134 Kb',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 1234,
    name: {
      name: 'Mappe 2',
      type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
    },
    size: '134 Kb',
    children: [
      {
        key: 112342,
        name: {
          name: 'Mappe 2-1',
          type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
        },
        size: '38 Kb',
      },
      {
        key: 13542622,
        name: {
          name: '001_Byggetilladelse af 4. juli 2016.pdf',
          type: { icon: 'file-pdf', iconStyle: 'fad', color: 'red' },
        },
        size: '134 Kb',
      },
      {
        key: 1345345234521,
        name: {
          name: 'Hus byggetilladelse af 7. Nov.docx',
          type: { icon: 'file-word', iconStyle: 'fad', color: 'blue' },
        },
        size: '134 Kb',
      },
      {
        key: 1345263,
        name: {
          name: 'Mappe 2-3',
          type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
        },
        size: '38 Kb',

        children: [
          {
            key: 13324535231,
            name: {
              name: 'Mappe 2-3-1',
              type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
            },
            size: '134 Kb',

            children: [
              {
                key: 1316276091,
                name: {
                  name: 'Mappe 2-3-1-1',
                  type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
                },
                size: '38 Kb',
              },
              {
                key: 1318902,
                name: {
                  name: 'Mappe 2-3-1-2',
                  type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
                },
                size: '134 Kb',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 2,
    name: {
      name: 'Mappe 3',
      type: { icon: 'folder', iconStyle: 'fas', color: 'yellow' },
    },
    size: '134 Kb',
  },
];

export default data;
